// Module
var code = `<label class="toolbox-label">Group by:</label> <div class="toolbox-content"> <rb-select class="bid-manager-select" ng-model="\$ctrl.groupedBy" name="groupBy" ng-change="\$ctrl.onGroupByChanged()"> <rb-option ng-repeat="groupBy in \$ctrl.groupableBy" value="groupBy.id"> <span>{{::groupBy.label}}</span> </rb-option> </rb-select> </div> `;
// Exports
export default code;